module.exports = __webpack_public_path__ + "static/MarkCatangui-2a6c900ddd6d86e21cc3793a00b31966.jpg";